import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { CheckItem } from '../CheckItem';
import { FlowSteps } from '../FlowSteps';
import { bonuses } from '../../data/bonuses';
export function BonusesSection() {
  return <PageSection labelledBy="bonuses-title" data-id="element-70" data-mp="vcvd0c3vbdnj">
      <SectionHeading id="bonuses-title" title="+ 5 bonos prácticos incluidos" subtitle="Además de los 10 volúmenes principales, recibís cinco herramientas diseñadas para facilitar la explicación, consulta y aplicación de los contenidos." data-id="element-71" data-mp="vdwqsoc9qe8y" />
      <div className="mt-8 space-y-5" data-id="element-72" data-mp="19c4qh40ovtnt">
        {bonuses.map(b => <article key={b.number} className="overflow-hidden rounded-xl border border-accent-500/30 bg-carbon-900" data-id="element-73" data-mp="199ijb5hpng64">
            <div className="p-6 md:p-7" data-id="element-74" data-mp="22091m5214yxw">
              <p className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-[0.25em] text-accent-400 md:text-base" data-id="element-75" data-mp="21z7m9odzdqad">
                <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-76" data-mp="26stt2zxgqzy9" />
                Bono {b.number}
              </p>
              <h3 className="mt-2 text-2xl font-extrabold uppercase leading-tight text-white md:text-3xl" data-id="element-77" data-mp="2h6nxbn0m8ws1">{b.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-carbon-300 md:text-[17px]" data-id="element-78" data-mp="2vvk31df79xph">{b.description}</p>
              <p className="mt-5 text-sm font-semibold text-carbon-300 md:text-base" data-id="element-79" data-mp="2r3k7rya2rsz8">{b.listIntro}</p>
              <ul className="mt-3 grid gap-x-6 gap-y-2.5 text-base text-carbon-200 sm:grid-cols-2" data-id="element-80" data-mp="34uyt4brgg69g">
                {b.list.map(item => <CheckItem key={item} data-id="element-81" data-mp="2zwdom05670f7">{item}</CheckItem>)}
              </ul>
            </div>
            <div className="border-t border-carbon-800 bg-carbon-950 px-6 py-4 md:px-7" data-id="element-82" data-mp="3etnyx662u09c">
              <FlowSteps steps={b.flow} data-id="element-83" data-mp="39week4xjoesd" />
            </div>
          </article>)}
      </div>
    </PageSection>;
}